(function () {
    'use strict';

    angular.module('swif.framework')
        .factory('swifOpenbaseService', swifOpenbaseService);

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseService
     * @requires swif.openbase.swifOpenbaseConsumableService
     * @requires swif.openbase.swifOpenbaseDepartmentService
     * @requires swif.openbase.swifOpenbaseEquipmentService
     * @requires swif.openbase.swifOpenbasePartnerService
     * @requires swif.openbase.swifOpenbaseSiteService
     * @requires swif.openbase.swifOpenbaseTeamService
     * @requires swif.openbase.swifOpenbaseLanguageService
     * @requires swif.openbase.swifOpenbaseBarcodesService
     * @requires swif.openbase.swifOpenbaseGroupsService
     * @requires swif.openbase.swifOpenbaseCustomFieldsService
     * @requires swif.openbase.swifOpenbaseUtilsService
     * @requires swif.openbase.swifOpenbaseUtilsService
     * @description
        ```
        service.consumable;
        service.department;
        service.equipment;
        service.partner;
        service.site;
        service.team;
        service.user;
        ```
     **/
    function swifOpenbaseService(
        swifOpenbaseBANService,
        swifOpenbaseConsumableService,
        swifOpenbaseDepartmentService,
        swifOpenbaseEquipmentService,
        swifOpenbasePartnerService,
        swifOpenbaseSiteService,
        swifOpenbaseCompanyService,
        swifOpenbaseTeamService,
        swifOpenbaseUserService,
        swifOpenbaseLanguageService,
        openbaseWizardService,
        swifOpenbaseBarcodesService,
        swifOpenbaseGroupsService,
        swifOpenbaseCustomFieldsService,
        swifOpenbaseUtilsService
    ) {
        'ngInject';
        var service = {};
        service.ban = swifOpenbaseBANService;
        service.consumable = swifOpenbaseConsumableService;
        service.department = swifOpenbaseDepartmentService;
        service.equipment = swifOpenbaseEquipmentService;
        service.partner = swifOpenbasePartnerService;
        service.site = swifOpenbaseSiteService;
        service.team = swifOpenbaseTeamService;
        service.company = swifOpenbaseCompanyService;
        service.user = swifOpenbaseUserService;
        service.language = swifOpenbaseLanguageService;
        service.wizard = openbaseWizardService;
        service.barcode = swifOpenbaseBarcodesService;
        service.group = swifOpenbaseGroupsService;
        service.groups = swifOpenbaseGroupsService;
        service.customfields = swifOpenbaseCustomFieldsService;
        service.utils = swifOpenbaseUtilsService;
        return service;
    }

})();
